import { Usuario, Credencial, AlertaSeguridad, EstadisticaSeguridad } from '../types';

// Usuarios de ejemplo
export const usuariosMock: Usuario[] = [
  {
    id: '1',
    nombre: 'Admin Principal',
    email: 'admin@empresa.com',
    rol: 'admin',
    ultimoAcceso: new Date('2025-04-28T10:30:00'),
    autorizaciones: ['panel_completo', 'configuracion_sistema', 'gestion_usuarios']
  },
  {
    id: '2',
    nombre: 'Ana Martínez',
    email: 'amartinez@empresa.com',
    rol: 'analista',
    ultimoAcceso: new Date('2025-04-27T16:45:00'),
    autorizaciones: ['monitoreo_seguridad', 'gestion_incidentes']
  },
  {
    id: '3',
    nombre: 'Carlos Rodríguez',
    email: 'crodriguez@empresa.com',
    rol: 'usuario',
    ultimoAcceso: new Date('2025-04-28T09:15:00'),
    autorizaciones: ['acceso_basico', 'gestion_credenciales_propias']
  }
];

// Credenciales de ejemplo
export const credencialesMock: Credencial[] = [
  {
    id: '101',
    tipo: 'bancaria',
    nombre: 'Cuenta Corporativa Principal',
    usuario: 'empresa_corp',
    fechaActualizacion: new Date('2025-03-15T08:30:00'),
    nivelAcceso: 5
  },
  {
    id: '102',
    tipo: 'social',
    nombre: 'Twitter Corporativo',
    usuario: '@EmpresaOficial',
    fechaActualizacion: new Date('2025-04-10T14:20:00'),
    nivelAcceso: 3
  },
  {
    id: '103',
    tipo: 'empresarial',
    nombre: 'Base de Datos Central',
    usuario: 'admin_db',
    fechaActualizacion: new Date('2025-04-22T11:45:00'),
    nivelAcceso: 5
  },
  {
    id: '104',
    tipo: 'empresarial',
    nombre: 'Sistema CRM',
    usuario: 'admin_crm',
    fechaActualizacion: new Date('2025-04-18T09:30:00'),
    nivelAcceso: 4
  },
  {
    id: '105',
    tipo: 'bancaria',
    nombre: 'Cuenta Nóminas',
    usuario: 'finanzas_nominas',
    fechaActualizacion: new Date('2025-04-05T10:15:00'),
    nivelAcceso: 4
  }
];

// Alertas de seguridad de ejemplo
export const alertasMock: AlertaSeguridad[] = [
  {
    id: 'a001',
    tipo: 'intrusion',
    nivel: 'alto',
    mensaje: 'Detección de múltiples intentos de acceso fallidos',
    fecha: new Date('2025-04-28T03:14:00'),
    estado: 'investigando',
    origen: '192.168.44.12',
    detalles: 'Intentos repetidos de login en el panel de administración desde ubicación no habitual'
  },
  {
    id: 'a002',
    tipo: 'vulnerabilidad',
    nivel: 'medio',
    mensaje: 'Actualización de seguridad pendiente en servidor web',
    fecha: new Date('2025-04-27T18:30:00'),
    estado: 'activa',
    detalles: 'CVE-2025-1234 requiere actualización prioritaria del sistema'
  },
  {
    id: 'a003',
    tipo: 'phishing',
    nivel: 'crítico',
    mensaje: 'Campaña de phishing dirigida detectada',
    fecha: new Date('2025-04-28T07:50:00'),
    estado: 'activa',
    detalles: 'Múltiples correos maliciosos detectados simulando ser del departamento de finanzas'
  },
  {
    id: 'a004',
    tipo: 'malware',
    nivel: 'bajo',
    mensaje: 'Malware potencial bloqueado',
    fecha: new Date('2025-04-26T12:20:00'),
    estado: 'resuelta',
    origen: 'Estación de trabajo Marketing-05',
    detalles: 'Archivo adjunto sospechoso bloqueado por el firewall'
  },
  {
    id: 'a005',
    tipo: 'acceso_no_autorizado',
    nivel: 'alto',
    mensaje: 'Acceso a datos sensibles fuera de horario laboral',
    fecha: new Date('2025-04-28T01:30:00'),
    estado: 'investigando',
    origen: 'Usuario: jperez',
    detalles: 'Acceso a la base de datos de clientes a las 01:30 AM'
  },
];

// Estadísticas de seguridad
export const estadisticasMock: EstadisticaSeguridad = {
  intentosBloqueo: 2458,
  vulnerabilidadesDetectadas: 17,
  amenazasActivas: 8,
  nivelRiesgo: 42, // 0-100
  ultimaActualizacion: new Date('2025-04-28T10:00:00')
};

// Actividad reciente para el panel de control
export const actividadRecienteMock = [
  {
    id: 'act001',
    usuario: 'amartinez',
    accion: 'Actualización de credenciales',
    recurso: 'Twitter Corporativo',
    timestamp: new Date('2025-04-28T09:45:00')
  },
  {
    id: 'act002',
    usuario: 'Sistema',
    accion: 'Backup automático',
    recurso: 'Base de datos principal',
    timestamp: new Date('2025-04-28T04:00:00')
  },
  {
    id: 'act003',
    usuario: 'crodriguez',
    accion: 'Inicio de sesión',
    recurso: 'Panel de control',
    timestamp: new Date('2025-04-28T09:15:00')
  },
  {
    id: 'act004',
    usuario: 'admin',
    accion: 'Configuración de política de seguridad',
    recurso: 'Firewall',
    timestamp: new Date('2025-04-27T17:30:00')
  },
  {
    id: 'act005',
    usuario: 'Sistema',
    accion: 'Bloqueo de amenaza',
    recurso: 'Endpoint: Marketing-05',
    timestamp: new Date('2025-04-26T12:20:00')
  }
];